<script lang="ts">
  import {
    sortablePreventDOMManipulation,
    sortablePreventUnmovableItemsFromMoving,
    sortableForceFallbackForFirefox,
    stopPropagation,
  } from "./genericHandlers";
  import Card from "./SoundCard.svelte";
  import {
    existingCardSelected,
    librarySoundSelected,
    soundBoard,
  } from "./store";
  import Upload from "./Upload.svelte";
  import SceneTitle from "./SceneTitle.svelte";
  import { CardKinds, PlaySettings } from "./SoundCard";
  import { SortableList } from "@jhubbardsf/svelte-sortablejs";
  import CloseSceneButton from "./CloseSceneButton.svelte";
  import { isFocusedScene } from "./global";
    import UploadDisabled from "./UploadDisabled.svelte";

  // It is okay that this file is aware of FreeformScene the class, and so it operates on its internals.
  export let sceneId;
  export let scene; // TODO BL: Stop trusting that this is actually a freeform scene.
  export let duplicateCallback: (evt) => void;

  let isOpen: boolean = isFocusedScene(scene);

  let cards = [];

  let draggingFromDrawer = false;
  librarySoundSelected.subscribe((newVal) => {
    draggingFromDrawer = newVal !== null;
  });

  const handleNameChangeRequest = (newName) => {
    soundBoard.RenameScene(sceneId, newName);
  };
  const handleUpdate = (evt) => {
    sortablePreventDOMManipulation(evt);
    soundBoard.UpdateVoid(() => {
      scene.MoveCardInScene(evt.oldIndex, evt.newIndex);
    });
  };
  const handleAdd = (evt) => {
    sortablePreventDOMManipulation(evt);
    if (draggingFromDrawer) {
      soundBoard.UpdateVoid(() => {
        const oldIdx = scene.cards.length;
        scene.AddCard(
          $librarySoundSelected.Name,
          $librarySoundSelected.Data,
          CardKinds.Plain,
        );
        scene.MoveCardInScene(oldIdx, evt.newIndex);
      });
    } else {
      const cardId = evt.item.id.replace("soundcard-", "");
      soundBoard.UpdateVoid(() => {
        const idx = scene.cards.length;
        scene.cards.push($existingCardSelected);
        scene.card_indices.set($existingCardSelected.id, idx);
        scene.MoveCardInScene(idx, evt.newIndex);
      });
    }
  };
  const handleRemove = (evt) => {
    sortablePreventDOMManipulation(evt);
    cards[evt.oldIndex].stop();
    const card = scene.getCardAtIdx(evt.oldIndex);
    soundBoard.UpdateVoid(() => {
      scene.DeleteCard(card.id);
    });
  };

  const handleChoose = (evt) => {
    sortablePreventDOMManipulation(evt);
    const card = scene.getCardAtIdx(evt.oldIndex);
    existingCardSelected.set(card);
  };
  const handleEnd = (evt) => {
    sortablePreventDOMManipulation(evt);
    existingCardSelected.set(null);
  };
  export function stopAll() {
    for (let i = 0; i < cards.length; i++) {
      cards[i].stop();
    }
  }
  const handleNameChange = (sceneId, cardId, newName) => {
    soundBoard.RenameCard(sceneId, cardId, newName);
  };

  const handlePlaySettingsChange = (
    sceneId,
    cardId,
    mutator: (PlaySettings) => PlaySettings,
  ) => {
    soundBoard.ChangeCardPlaySettings(sceneId, cardId, mutator);
  };
</script>

<article class="soundboard-lane editable-icon">
  <CloseSceneButton {scene} onSceneClosing={stopAll}></CloseSceneButton>
  <div>
    <details bind:open={isOpen}>
      <summary class="soundboard-lane-header">
        <SceneTitle
          nameChangeCallback={handleNameChangeRequest}
          {scene}
          {duplicateCallback}
        />
        <!-- BL: This div is only here so that the grid template columns for the soundboard-lane-header luine up -->
        <div></div>
      </summary>
      <div on:pointerdown={stopPropagation} on:mousedown={stopPropagation}>
        <SortableList
          class="soundboard-lane-container"
          swapThreshold={0.75}
          animation={250}
          easing="ease-in-out"
          onAdd={handleAdd}
          onRemove={handleRemove}
          onUpdate={handleUpdate}
          onStart={handleChoose}
          onEnd={handleEnd}
          onMove={sortablePreventUnmovableItemsFromMoving}
          forceFallback={sortableForceFallbackForFirefox()}
          handle=".soundcard"
          filter=".unsortable"
          group={{ name: "sounds-on-lanes" }}
          ghostClass="sound-ghost"
        >
          {#each scene["cards"] as card, idx (card.id)}
            <Card
              {card}
              sceneId={scene.id}
              bind:this={cards[idx]}
              playSettingsChangedCallback={handlePlaySettingsChange}
              nameChangeCallback={handleNameChange}
            />
          {/each}
          <UploadDisabled />
        </SortableList>
      </div>
    </details>
  </div>
</article>
